<template>
  <v-list-group
      v-show="hasChildData(item)"
      :group="item.group"
      :prepend-icon="item.icon"
      :sub-group="false"
      no-action
      :value="active"
  >
    <template v-slot:activator>
      <v-list-item-content>
        <v-list-item-title class="text-wrap">{{ item.title }}</v-list-item-title>
      </v-list-item-content>
    </template>
    <template v-for="(child, i) in children">
      <list-sub-group
          v-if="child.group != null"
          :key="`sub-group-${i}`"
          :item="child"
      />
      <list-item
          v-else
          v-show="hasModuleAccess(child.meta)"
          :key="`item-${i}`"
          :icon="child.icon"
          :subtext="child.subtext"
          :to="child.to"
          :title="child.title"
      />
    </template>
  </v-list-group>
</template>

<script>
// Utilities
import kebabCase from 'lodash/kebabCase';
import ListItem from './Item';
import {readHasModuleAccess} from '@/store/main/getters';

export default {
  name: 'ListGroup',
  components: {
    ListItem,
    ListSubGroup: () => import('./SubGroup'),
  },
  inheritAttrs: false,
  props: {
    item: {
      type: Object,
      default: () => ({
        text: '',
        group: '',
        children: [],
      }),
    },
    subGroup: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    children() {
      return this.item.children.map((item) => ({
        ...item,
        to: item.to,
      }));
    },
    group() {
      return this.genGroup(this.item.children, this.item);
    },
    active() {
      const found = this.item.children.filter(
          (item) => item.to === this.$route.path,
      );
      return found.length > 0 ? true : false;
    },
  },
  methods: {
    genGroup(children) {
      return children
          .map((item) => {
            const parent = item.group || this.item.group;
            let group = `${parent}/${kebabCase(item.to)}`;
            if (item.children) {
              group = `${group}|${this.genGroup(item.children)}`;
            }
            return group;
          })
          .join('|');
    },

    checkNullUndefined(val) {
      return (val !== null && val !== undefined);
    },
    hasModuleAccess(val) {
      return readHasModuleAccess(this.$store)(val);
    },

    hasChildData(val) {
      return val?.children.length > 0
    }

    // canViewModule(item) {
    //     const path = item.to.split('/')
    //     const cruds = ['list', 'create', 'edit', 'admin']
    //     if (path.length > 1 && cruds.includes(path[path.length - 1])) {
    //         const operation = path[path.length - 1]
    //         const module = path[path.length - 2]
    //         let settings = window.getApp.current_user.role.settings
    //         if (this.checkNullUndefined(settings)) {
    //             const canView = settings.filter(s => s.modulo === module)
    //             if (canView.length > 0) {
    //                 return canView[0].metodos[operation]
    //             }
    //         }
    //     }
    //     return true
    // }
  },
  data: () => ({}),
};
</script>
